import type { ID } from '../types';
import BaseObject from './BaseObject';
import { OrderedMap } from 'immutable';

export default class Collection<T> extends BaseObject {
  items: OrderedMap<ID, T>;
  limit: number;
  offset: number;
  persistedItemsOnServer: number;

  constructor(props: any = {}) {
    super(props);

    this.items = OrderedMap(props.items);

    // for handling results pagination
    this.limit = props.limit || 100;
    this.offset = props.offset || 0;
    this.persistedItemsOnServer = props.persistedItemsOnServer || -1;
  }

  get canLoadMore(): boolean {
    return this.persistedItemsOnServer == -1 || this.items.count() < this.persistedItemsOnServer;
  }

  get hasUnpersistedMembers(): boolean {
    return this.items.some((_, id: ID) => /^temp_/.test(id.toString()));
  }
}
